import { transportDamage } from './transport-damage.i18n';

export const en = {
  transportDamage,
};
